import commonHelper from '@/app/utility/common.helper.utility';

export default {
  name: 'sourcingApprovalDetails',
  props: ['cardName'],
  watch: {
    currentPage1: function() {
      if (this.cardName === 'pendingPOSync') {
        this.getPendingPoSyncData();
      }
    },
    perPage1: function() {
      this.currentPage1 = 1;
      if (this.cardName === 'pendingPOSync') {
        this.getPendingPoSyncData();
      }
    }
  },
  data() {
    return {
      loader: false,
      perPage1: commonHelper.perPageRecord,
      pageOptions1: commonHelper.getPageOption(),
      totalRows1: null,
      currentPage1: 1,
      sourcingDashboardDetailsData: [],
      sourcingDashboardDetailsFields: [],
      sortFlag: {
        creationDate: true,
        subDate: false,
        vendorName: false,
        userEmail: false
      }
    };
  },
  created() {
    if (this.cardName === 'pendingPOSync') {
      this.sourcingDashboardDetailsFields = [
        // {
        //   key: 'vendor_site_name',
        //   label: 'Vendor site Name',
        //   class: ''
        // },
        {
          key: 'ou_name',
          label: 'OU Name',
          class: ''
        },
        {
          key: 'rfp_number',
          label: 'RFP Number',
          class: ''
        },
        {
          key: 'creation_date',
          label: 'Creation Date',
          class: ''
        },
        {
          key: 'po_buyer',
          label: 'PO Buyer',
          class: ''
        },

        {
          key: 'po_buyer_email_id',
          label: 'PO Buyer Email id',
          class: ''
        },
        {
          key: 'posted_date',
          label: 'Posted Date',
          class: ''
        },
        {
          key: 'status_code',
          label: 'Status Code',
          class: ''
        },
        {
          key: 'status_message',
          label: 'Status Message',
          class: ''
        }
      ];
      this.getPendingPoSyncData();
    } else {
      this.sourcingDashboardDetailsData = [];
      this.sourcingDashboardDetailsFields = [];
    }
  },
  methods: {
  getPendingPoSyncData() {
  const payload = {
    _page: this.currentPage1 - 1,
    _limit: this.perPage1
  };
  this.loader = true;
  this.$store
    .dispatch('vendorDashboard/getPendingPoSyncData', payload)
    .then(resp => {
      this.loader = false;
      if (resp.status == 200) {
        const result = resp.data.data.page;
        this.sourcingDashboardDetailsData = result.map(item => {
          return {
            ...item,
            status_code: item.status_code === "E" ? "Error" : item.status_code
          };
        });
        this.totalRows1 = resp.data.data.total_elements;
      }
    });
}

  }
};
